// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line-wrapper[data-v-fa04539e]{height:26.042vw;width:72.917vw}.line-wrapper .noDateShow[data-v-fa04539e]{height:26.042vw;width:67.708vw;position:absolute;top:0;left:0;background-color:hsla(0,0%,100%,.7);z-index:100;text-align:center;line-height:20.833vw}.line-wrapper .line-content[data-v-fa04539e]{height:26.042vw;width:72.917vw}", ""]);
// Exports
module.exports = exports;
